$(document).ready(function() {
    var $video = $('#background-video');
    $video.on('loadeddata', function() {
        $video.addClass('loaded');
        $('.video-container').addClass('loadedVideo');
    });
});

if($('.in-index').length){
    $('.homepage-group-title').first().before($('<div class="customProductsList"></div>'))
    $('div[class*="homepage-products-heading-"]').appendTo('.customProductsList')
    $('.customProductsList>div').first().addClass('active')
    $('.products-block').first().addClass('activeProductsList')
    $('[class*="homepage-products-heading-"]').each(function() {
        var fullClass = $(this).attr('class');
        var match = fullClass.match(/homepage-products-heading-(\d+)/);
        if (match && match[1]) {
            $(this).attr('data-number', match[1])
        }
    });
}

$(document).on('click', '.customProductsList>div', function(){
    $('.customProductsList>div').removeClass('active')
    $(this).addClass('active')
    $('.products').removeClass('activeProductsList')
    $('.products[data-testid="productGroup_'+$(this).attr('data-number')+'"]').addClass('activeProductsList')
})